import { useEffect, useRef } from "react";

// Fades children up as they enter the viewport. Uses IntersectionObserver
// (no scroll listeners) and a single class toggle; CSS lives in index.css.
const Reveal = ({ as: Tag = "div", index = 0, className = "", style, children, ...rest }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    if (!("IntersectionObserver" in window)) {
      el.classList.add("is-visible");
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`reveal ${className}`.trim()}
      style={{ "--i": index, ...style }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
